import { CardGroupBudgetSpendByMonth, HighnoteProductType, ProjectGroupBudgetSpendByMonth } from 'API';
import { format } from 'date-fns';

export const getMonthlySpendFromMonthlyBudgets = (
  items: (CardGroupBudgetSpendByMonth | ProjectGroupBudgetSpendByMonth | null)[] | undefined
): number => {
  const currentYearMonth = format(new Date(), 'yyyy-MM');
  if (!items) return 0;

  // Filter out null items once
  const filteredItems = items.filter(
    (item): item is CardGroupBudgetSpendByMonth | ProjectGroupBudgetSpendByMonth => item !== null
  );

  // Find the item matching the current year and month
  const foundItem = filteredItems.find((item) => item.yearAndMonth === currentYearMonth);

  // Return the amount if found, otherwise 0
  return foundItem ? foundItem.amount ?? 0 : 0;
};

export const getCardTypeDescription = (cardType?: HighnoteProductType) =>
  cardType === HighnoteProductType.CREDIT ? 'Business Credit' : 'Business Debit';
